import * as yup from "yup";

const loginSchema = yup.object({
    userName: yup.string().required("User Name is required."),

    password: yup.string().required("Password is required.")
});

export default loginSchema;
